import React from 'react';

import { Content as CommonContent } from './Types.jsx';
import { withBlockRendering } from '../utility/Config.jsx';
import CellItemContainer from './CellItemContainer.jsx';
import * as CellItemImage from './CellItemImage.jsx';
import * as CellItemMeta from './CellItemMeta.jsx';
import Name from '../utility/Name.jsx';

// #region CONTAINER

const Blocks = {
    get: (group) => [
        ...CommonContent.get(group),
        {
            id: Name.Block.Inventory.Image,
            component: CellItemImage.Component,
            config: {
                Block: CellItemImage.TypeConfig.panel.block(),
                Style: CellItemImage.TypeConfig.panel.style()
            },
            display: 'Item Image',
            group,
            image: ''
        },
        {
            id: Name.Block.Inventory.Meta,
            component: CellItemMeta.Component,
            config: {
                Block: CellItemMeta.TypeConfig.panel.block(),
                Style: CellItemMeta.TypeConfig.panel.style()
            },
            display: 'Item Meta',
            group,
            image: ''
        }
    ]
}
const LineItemContainer = withBlockRendering(CellItemContainer, Blocks.get(), (props, block) => {
    if (!block.type) {
        return;
    }
    let blockExtras;
    if (props.onBlockExtras) {
        blockExtras = props.onBlockExtras(props, block);
    }
    switch (block.type.value) {
        case Name.Block.Columns:
            if (block.config && block.config.Block && block.config.Block.renderHeaderOnlyFirst) {
                if (!blockExtras) {
                    blockExtras = {};
                }
                blockExtras.renderHeader = props.index == 0;
            }
            break;
    }
    return blockExtras;
});

// #endregion CONTAINER

export {
    Blocks,
    LineItemContainer as Component
}